export const logout = 'logout'
export const login = 'login'
export const send_login_request = 'send_login_request'
export const send_login_success = 'send_login_success'
export const send_login_failure = 'send_login_failure'
